import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingHeading, LandingParagraph, LandingHero} from '@tempo/landing';
import {useLocation} from '@app/hooks/use-location';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useLegacyUser} from '@deezer/react-user';

export const HiFiHero: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['hifi']});
	const {getDeezerUrl} = useLocation();
	const [user] = useLegacyUser();

	const isHaasEligible = user?.__DZR_GATEKEEPS__?.haas_project !== false;

	return (
		<LandingHero data-testid="hifi-hero-section">
			<LandingHeading
				as="h1"
				color="black"
				bgClip="text"
				lineHeight="1.15"
				bgGradient="linear(82deg,#f7e2ae,#f6e5b8 27%,#e4ca8d 47%,#d2b062 67%,#cca555)"
			>
				{t('generic_title_highfidelitysound_web')}
				<br />
				{t('deezerhifilandingpage_title_elevatelisteningexperience_web')}
			</LandingHeading>
			{isHaasEligible && (
				<LandingParagraph as="h3" color="white">
					{t('downloadlandingpage_text_availablepaidsubscriptionusers_web')}
				</LandingParagraph>
			)}
			<LandingButtonLink
				tracking={{
					eventaction: 'hero-cta',
					eventcategory: 'hifi',
					eventlabel: 'discover-offers',
				}}
				href={getDeezerUrl('/offers')}
				data-testid="hifi-hero-cta"
				isMain
			>
				{t('generic_action_seeallavailableplans_web')}
			</LandingButtonLink>
		</LandingHero>
	);
};
